module.exports = __webpack_public_path__ + "static/media/YeselfLogoWhiteVector.04b037ed.svg";